import $foreign from "./foreign.cjs";
var copyRecord = $foreign.copyRecord;
var unsafeDelete = $foreign.unsafeDelete;
var unsafeInsert = $foreign.unsafeInsert;
var unsafeModify = $foreign.unsafeModify;
var unsafeRename = $foreign.unsafeRename;
export { copyRecord, unsafeDelete, unsafeInsert, unsafeModify, unsafeRename };
